export default __webpack_public_path__ + "static/media/4.14301207.jpg";